import { Api } from "../config/request";

export default {
    bulkUpdatePolygon(payload) {
        return Api.put("/polygon/bulk-update", payload);
    },
};